var _g, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPuppetAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.1724 27.4483C12.9879 27.4483 6 29.2369 6 36.3829C6 43.5262 12.9453 45.3793 21.1724 45.3793C29.3549 45.3793 36.3448 43.5907 36.3448 36.4446C36.3448 29.2986 29.3995 27.4483 21.1724 27.4483Z",
    fill: "#FBE7EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8621 24.6897C27.6041 24.6897 32.2069 20.0873 32.2069 14.3459C32.2069 8.60442 27.6041 4 21.8621 4C16.12 4 11.5172 8.60442 11.5172 14.3459C11.5172 20.0873 16.12 24.6897 21.8621 24.6897Z",
    fill: "#FBFBFB"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.8227 31.586C43.8227 35.7169 40.4749 39.0641 36.3447 39.0641C32.2145 39.0641 28.8667 35.7169 28.8667 31.586C28.8667 27.4567 32.2146 24.108 36.3447 24.108C40.4748 24.108 43.8227 27.4567 43.8227 31.586Z",
    fill: "#FBE7EE",
    stroke: "#D20E50",
    strokeWidth: 1.1359
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3407 33.9425C36.7374 33.9425 37.0528 34.2587 37.0528 34.6465C37.0528 35.0343 36.7374 35.3505 36.3487 35.3505C35.9585 35.3505 35.6407 35.0343 35.6407 34.6465C35.6407 34.2587 35.9553 33.9425 36.3407 33.9425ZM36.3407 27.8333C36.7285 27.8333 37.0447 28.1495 37.0447 28.5374V32.0937C37.0447 32.4815 36.7285 32.7977 36.3407 32.7977C35.9529 32.7977 35.6367 32.4815 35.6367 32.0937V28.5374C35.6367 28.1495 35.9529 27.8333 36.3407 27.8333Z",
    fill: "#D20E50"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0.15625,
    y: 0.8125,
    width: 42.0323,
    height: 53.0668,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.53125,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.65625
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.65625
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.494118 0 0 0 0 0.0313726 0 0 0 0 0.188235 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuppetAlert);
export default __webpack_public_path__ + "static/media/puppetAlert.24a93e1d.svg";
export { ForwardRef as ReactComponent };